import { directive } from 'lit-html';
import { VirtualScroller } from './uni-virtualizer/lib/VirtualScroller.js';
import { LitMixin } from './repeat.js';
export class LitScroller extends LitMixin(VirtualScroller) {
}
const partToScroller = new WeakMap();
/**
 * A lit-html directive that turns its parent node into a virtual scroller.
 *
 * See ScrollConfig interface for configuration options.
 */
export const scroll = directive((config) => async (part) => {
    // Retain the scroller so that re-rendering the directive's parent won't
    // create another one.
    let scroller = partToScroller.get(part);
    if (!scroller) {
        if (!part.startNode.isConnected) {
            await Promise.resolve();
        }
        const { renderItem, layout, scrollTarget, useShadowDOM } = config;
        scroller = new LitScroller({ part, renderItem, layout, scrollTarget, useShadowDOM });
        partToScroller.set(part, scroller);
    }
    Object.assign(scroller, {
        items: config.items,
        totalItems: config.totalItems === undefined ? null : config.totalItems,
        scrollToIndex: config.scrollToIndex === undefined ? null : config.scrollToIndex,
    });
});
